import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { API_BASE_URL } from "../config/api";
const API_URL = `${API_BASE_URL}/stores`;

export default function AddStore() {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [apiEndpoint, setApiEndpoint] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSuccess("");
    setError("");
    if (!name.trim() || !apiEndpoint.trim()) {
      setError(t('admin:fieldsRequired', 'Both fields are required.'));
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, apiEndpoint })
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.message || t('admin:failedAddStore', 'Failed to add store.'));
      }
      setSuccess(t('admin:storeAdded', 'Store added successfully!'));
      setName("");
      setApiEndpoint("");
    } catch (err: any) {
      setError(err.message || t('admin:failedAddStore', 'Failed to add store.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center bg-slate-50 py-10">
      <form
        onSubmit={handleSubmit}
        className="bg-white shadow-xl rounded-xl p-8 w-full max-w-md border border-slate-200"
      >
        <h2 className="text-2xl font-bold mb-6 text-center text-teal-700">{t('admin:addNewStore', 'Add New Store')}</h2>
        <div className="mb-4">
          <label className="block mb-1 font-medium text-slate-700">{t('admin:storeName', 'Store Name')}</label>
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-400"
            placeholder={t('admin:storeNamePlaceholder', 'e.g. Elora Main Store')}
            required
          />
        </div>
        <div className="mb-4">
          <label className="block mb-1 font-medium text-slate-700">{t('admin:apiEndpoint', 'API Endpoint')}</label>
          <input
            type="url"
            value={apiEndpoint}
            onChange={e => setApiEndpoint(e.target.value)}
            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-400"
            placeholder={t('admin:apiEndpointPlaceholder', 'e.g. https://api.example.com/all-data')}
            required
          />
        </div>
        {error && <div className="mb-3 text-red-600 text-sm">{error}</div>}
        {success && <div className="mb-3 text-green-600 text-sm">{success}</div>}
        <button
          type="submit"
          className="w-full bg-teal-600 hover:bg-teal-700 text-white font-semibold py-2 rounded-lg transition-all disabled:opacity-60"
          disabled={loading}
        >
          {loading ? t('admin:adding', 'Adding...') : t('admin:addStore', 'Add Store')}
        </button>
      </form>
    </div>
  );
}
